import AppHeaderBar from "./AppHeaderBar";
import AppNavBar from "./AppNavBar";

const MobilePageLayout = ({
  title,
  pageClassName = "installation-list-page",
  mainClassName = "installation-list-shell",
  setCookies,
  saveUser,
  children,
  showNav = true,
}) => {
  return (
    <div className={pageClassName}>
      <AppHeaderBar title={title} setCookies={setCookies} saveUser={saveUser} />
      <main className={mainClassName}>{children}</main>
      {showNav && <AppNavBar />}
    </div>
  );
};

export default MobilePageLayout;
